import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

// Kept in organism: uses transform centering, min-height, and responsive width
// that AbsolutePositionedAsset doesn't support.
export const StaticContainer = styled.div`
  width: 130%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  min-height: 360px;
  > * {
    min-height: 360px;
  }
  @media (max-width: ${breakpoints.md}) {
    width: 180%;
  }
`;
